module.exports = __webpack_public_path__ + "img/tengXunQiYe.d7194a7e.png";